import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

Vue.config.productionTip = false;

const shared = {
    appName: 'Organische Chemie',
    categories: {
        start: 'Startseite',
        stoffe: 'Stoffe',
        reaktionen: 'Reaktionstypen/Reaktionsmechanismen',
        gruppen: 'Funktionelle Gruppen',
        benennung: 'Benennung',
        karteikarten: 'Karteikarten',
        sonstiges: 'Sonstiges',
    },
    chapters: {
        stoffe: {
            home: 'Start',
            aldehyde: 'Aldehyde',
            alkane: 'Alkane',
            alkene: 'Alkene',
            alkine: 'Alkine',
            alkohole: 'Alkohole',
            amine: 'Amine',
            aromaten: 'Aromaten',
            carbon: 'Carbonsäuren',
            ester: 'Ester',
            ether: 'Ether',
            halogenkohlenwasserstoffe: 'Halogenkohlenwasserstoffe',
            ketone: 'Ketone',
            nitroalkane: 'Nitroalkane',
            aminosauren: 'Aminosäuren',
            kohlenhydrate: 'Kohlenhydrate',
            uebungen: 'Übungen',
        },
        reaktionen: {
            'home': 'Start',
            'elektrophile-addition': 'Elektrophile Addition',
            'elektrophile-substitution': 'Elektrophile Substitution',
            'radikalische-substitution': 'Radikalische Substitution',
            'estersynthese': 'Estersynthese',
        },
        gruppen: {
            home: 'Start',
            hydroxyl: 'Hydroxyl-Gruppe',
            carboxyl: 'Carboxyl-Gruppe',
            amino: 'Amino-Gruppe',
            ester: 'Ester-Gruppe',
            aldehyd: 'Aldehyd-Gruppe (Carbonyl)',
            keto: 'Keto-Gruppe (Carbonyl)',
            ether: 'Ether-Gruppe',
            nitro: 'Nitro-Gruppe',
            peptid: 'Peptidbindung'
        },
        benennung: {
            'home': 'Start',
            'anleitung': 'Anleitung',
            'benennung-uebungen': 'Übungen',
        },
        karteikarten: {
            'home': 'Start',
            'stoffklassen': 'Organische Stoffklassen',
            'reaktionen-nachweise': 'Reaktionen und Nachweise',
            'sonstiges': 'Sonstige Karteikarten',
        },
        sonstiges: {
            'home': 'Start',
            'hueckel': 'Hückel-Regel',
            'verschiebung-gg': 'Verschiebung des Gleichgewichts',
            'pks': 'Säurestärke',
            'induktiver-effekt': 'Induktiver Effekt',
            'mesomerie': 'Mesomerie',
            'allgemeine-uebungen': 'Allgemeine Übungen',
        },
    },
};

shared.install = function() {
    Object.defineProperty(Vue.prototype, '$global', {
        get() {
            return shared;
        },
    });
};

// noinspection JSCheckFunctionSignatures
Vue.use(shared);

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
